module.exports = __webpack_public_path__ + "static/media/Talq-main-static.f020d4b5.jpg";